import React from 'react'
import { IoChevronDown } from 'react-icons/io5'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from 'components/UI/BaseDropdown/dropdown-base'
import { FilterCriteria } from '../FilterStore'

interface FilterCriteriaSelectorProps {
  value: FilterCriteria
  onChange: (value: FilterCriteria) => void
}

const CRITERIA_OPTIONS: { value: FilterCriteria; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'one', label: 'One' },
  { value: 'neither', label: 'None' },
]

export function FilterCriteriaSelector({
  value,
  onChange,
}: FilterCriteriaSelectorProps) {
  const selectedLabel =
    CRITERIA_OPTIONS.find((opt) => opt.value === value)?.label || 'All'

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="mx-1 inline-flex h-6 cursor-pointer items-center gap-1 rounded-md border border-neutral-300 bg-white px-2 text-neutral-800"
        >
          <span className="text-sm font-medium tracking-[-0.2px]">
            {selectedLabel}
          </span>
          <IoChevronDown className="h-3.5 w-3.5 text-neutral-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-[100px] rounded-xl border border-neutral-200 bg-white p-1.5 shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1)]"
      >
        {CRITERIA_OPTIONS.filter((option) => option.value !== value).map(
          (option) => (
            <DropdownMenuItem
              key={option.value}
              onClick={() => onChange(option.value)}
              className="cursor-pointer rounded-lg px-3 py-2 text-sm text-neutral-700 hover:bg-neutral-100"
            >
              {option.label}
            </DropdownMenuItem>
          )
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
